import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/TreeRoots/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/TreeRoots/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/TreeRoots/GetById`, payload),
    Add: (payload) => Repository.post(`/api/TreeRoots/Add`, payload),
    Edit: (payload) => Repository.post(`/api/TreeRoots/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/TreeRoots/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/TreeRoots/ChangeStatus`, payload),
}
